import React from "react";
import AdminExerciseSelector from "./selectors/AdminExerciseSelector";
import UserExerciseSelector from "./selectors/UserExerciseSelector";
import ExerciseTaskHud from "./huds/ExerciseTaskHud";
import ExerciseMenu from "./ExerciseMenu";
import { useUser } from "../../context/userContext";
import { useDot } from "../../context/automatonContext";

/**
 * Orquestrador principal do submódulo de Exercícios.
 * Realiza a seleção automática entre a interface administrativa e a interface de usuário
 * baseada nas permissões e no estado do sistema.
 * * @author Willian
 * @param {Object} props Propriedades herdadas dos componentes de visualização.
 * @param {boolean} props.isAdmin Flag que indica se o seletor deve carregar o modo administrador.
 * @returns {JSX.Element} O seletor de exercícios apropriado (Admin ou User).
 */
const ExerciseSelector = (props) => {
  const { credential } = useUser();
  const { setAutomatonType } = useDot();

  /**
   * Lógica de decisão de renderização baseada no papel do usuário.
   * Utiliza blocos if completos conforme a diretriz de desenvolvimento.
   */
  if (props.isAdmin) {
    return (
      <AdminExerciseSelector
        {...props}
        credential={credential}
        setAutomatonType={setAutomatonType}
      />
    );
  }

  // Caso não seja admin, renderiza a interface padrão do aluno
  return (
    <UserExerciseSelector
      {...props}
      credential={credential}
      setAutomatonType={setAutomatonType}
    />
  );
};

/**
 * Exportações centralizadas dos componentes de Exercícios.
 * Facilita a importação em outros níveis da aplicação (como Sidebar ou Views).
 */
export { ExerciseSelector, ExerciseTaskHud, ExerciseMenu };
